import { Box, Divider, Typography } from "@mui/material";
import * as React from "react";
import { Link, IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ConfigData from "../config/config.json";
import { UserContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function WelcomePage() {
  const { user, setUser } = React.useContext(UserContext);
  const [formUploaded, setFormUploaded] = React.useState(false);

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/settings/getDocumentationForm",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(
            "Es wurde keine Vorlage für den Dokumenationsbogen hochgeladen!"
          );
        }
        return response;
      })
      .then(() => {
        setFormUploaded(true);
      })
      .catch(() => {
        setFormUploaded(false);
      });
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        padding: 3,
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "60%",
          flexDirection: "column",
          alignSelf: "center",
        }}
      >
        <Typography variant="h5" sx={{ alignSelf: "center" }}>
          Herstellungsbereitschaft
        </Typography>
        <Divider sx={{ m: 2 }}></Divider>

        <Typography variant="body1" sx={{ alignSelf: "center" }}>
          Die Überprüfung der Erfüllung der Verpflichtung zur Herstellung von
          Rezepturen erfolgt gemäß § 17 Abs. 4 ApBetrO. Dazu werden jährlich 100
          öffentliche Apotheken telefonisch kontaktiert und anhand
          unterschiedlicher Szenarien sowie Rezepturen hinsichtlich ihrer
          Herstellungsbereitschaft überprüft. Die Auswahl der Apotheken erfolgt
          zufällig.
        </Typography>

        <Typography variant="h5" sx={{ alignSelf: "center", marginTop: 15 }}>
          Dokumentationsbogen
        </Typography>
        <Divider sx={{ m: 2 }}></Divider>
        {/* <Typography variant='body1' sx={{alignSelf: 'center'}}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</Typography> */}
        {formUploaded ? (
          <>
            <Link
              sx={{ alignSelf: "center", width: "80px", height: "80px" }}
              href={
                webserver.protocol +
                "://" +
                webserver.host +
                ":" +
                webserver.port +
                "/settings/getDocumentationForm"
              }
            >
              <IconButton>
                <FileDownloadIcon
                  sx={{ width: "100%", height: "100%" }}
                ></FileDownloadIcon>
              </IconButton>
            </Link>
            <Typography variant="caption" sx={{ alignSelf: "center" }}>
              Herunterladen
            </Typography>
          </>
        ) : user.role === "EXAMINER" ? (
          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              textAlign: "center",
              alignSelf: "center",
              color: "#b50202",
            }}
          >
            Es wurde keine Vorlage für den Dokumenationsbogen hochgeladen. Bitte
            wenden Sie sich an den zuständigen Ansprechpartner bei der Kammer!
          </Typography>
        ) : (
          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              textAlign: "center",
              alignSelf: "center",
              color: "#b50202",
            }}
          >
            {
              "Es wurde keine Vorlage für den Dokumenationsbogen hochgeladen. Die Option zum Hochladen finden Sie unter Einstellungen -> Dokumentationsbogen!"
            }
          </Typography>
        )}
      </Box>
    </Box>
  );
}
